import apiUrl from '../../../../constants'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'bag-inscan-logs',
  components: { VueElementLoading },
  props: ['hubname', 'hubid'],
  data() {
    return {
      isLoading: false,
      isBagNoError: false,
      bagNoError: '',
      bagNo: '',
      responseDetails: [],
      showtable: false,
      requestLogData: {},
			showRequestModal: false,

    }
  },
  computed: {},
  filters: {},
  mounted() {},
  methods: {
    getShipmentDetails() {
      this.responseDetails = []
      if (this.bagNo == '') {
        this.isBagNoError = true
        this.bagNoError = 'The Bag Number field is required.'
        return false;
      } else {
        this.isBagNoError = false
        this.bagNoError = ''
      }
      this.isLoading = true
      axios({
        method: 'GET',
        'url': apiUrl.api_url_hubops + 'getBagHubInScanLog?bagNo=' + this.bagNo.trim() + '&currentHubId=' + this.hubid,
        'data': ({}),
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.showtable = true
            this.isLoading = false
            this.responseDetails = result.data.ResponseData
          } else {
            this.$alertify.error(result.data.ReturnMessage)
            this.isLoading = false
          }
        }, error => {
          this.isLoading = false
          console.error(error)
        })
    },
    clearError() {
      if (this.bagNo == '') {
        this.isBagNoError = false
        this.bagNoError = 'The Bag Number field is required.'
      } else {
        this.isBagNoError = false
        this.bagNoError = ''
      }
    },
    showRequestLog(data) {
			this.requestLogData = data;
			this.showRequestModal = true;
		},
    closeRequestModal() {
			this.showRequestModal = false;
			$(document.body).removeClass("modal-open");
			$(".modal-backdrop").remove();
		},
  }
}



// WEBPACK FOOTER //
// ./src/views/components/BagSorter/BagInscanLogs/BagInscanLogs.js